const toolbox = [
  {
    kind: 'category',
    name: '%{BKY_CATEGORY_START}',
    categorystyle: 'start_category',
    cssConfig: {
      icon: 'customIcon fa fa-flag-checkered'
    },
    contents: [
      {
        kind: 'block',
        type: 'start_on_boot'
      },
      {
        kind: 'block',
        type: 'machine_ifcontrol'
      },
      {
        kind: 'block',
        type: 'machine_ifzero_button'
      }
    ]
  },
  {
    kind: 'category',
    name: '%{BKY_CATEGORY_CONTROL}',
    categorystyle: 'control_category',
    cssConfig: {
      icon: 'customIcon fa fa-random'
    },
    contents: [
      {
        kind: 'block',
        blockxml: `
            <block type="time_sleep">
              <value name="SLEEP">
                <block type="math_number">
                  <field name="NUM">1</field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        type: 'controls_if',
        blockxml: `
          <block type="controls_if">
            <value name="IF0">
              <block type="logic_compare">
                <value name="A">
                  <block type="math_number">
                    <field name="NUM">1</field>
                  </block>
                </value>
                <value name="B">
                  <block type="math_number">
                    <field name="NUM">1</field>
                  </block>
                </value>
              </block>
            </value>
          </block>`
      },
      {
        kind: 'block',
        blockxml: `
          <block type="controls_if">
            <mutation else="1"></mutation>
            <value name="IF0">
              <block type="logic_compare">
                <value name="A">
                  <block type="math_number">
                    <field name="NUM">1</field>
                  </block>
                </value>
                <value name="B">
                  <block type="math_number">
                    <field name="NUM">1</field>
                  </block>
                </value>
              </block>
            </value>
          </block>`
      },
      {
        kind: 'block',
        blockxml: `
          <block type="controls_if">
            <mutation elseif="1" else="1"></mutation>
            <value name="IF0">
              <block type="logic_compare">
                <value name="A">
                  <block type="math_number">
                    <field name="NUM">1</field>
                  </block>
                </value>
                <value name="B">
                  <block type="math_number">
                    <field name="NUM">1</field>
                  </block>
                </value>
              </block>
            </value>
            <value name="IF1">
              <block type="logic_compare">
                <value name="A">
                  <block type="math_number">
                    <field name="NUM">2</field>
                  </block>
                </value>
                <field name="OP">GT</field>
                <value name="B">
                  <block type="math_number">
                    <field name="NUM">1</field>
                  </block>
                </value>
              </block>
            </value>
          </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="controls_repeat_ext">
              <value name="TIMES">
                <block type="math_number">
                  <field name="NUM">10</field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="controls_whileUntil">
              <value name="BOOL">
                <block type="logic_boolean">
                  <field name="BOOL">TRUE</field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="controls_for">
              <field name="VAR">i</field>
              <value name="FROM">
                <block type="math_number">
                  <field name="NUM">1</field>
                </block>
              </value>
              <value name="TO">
                <block type="math_number">
                  <field name="NUM">10</field>
                </block>
              </value>
              <value name="BY">
                <block type="math_number">
                  <field name="NUM">1</field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="controls_forEach">
              <field name="VAR">i</field>
              <value name="LIST">
                <block type="lists_create_with">
                  <mutation items="3"></mutation>
                  <value name="ADD0">
                    <block type="math_number">
                      <field name="NUM">1</field>
                    </block>
                  </value>
                  <value name="ADD1">
                    <block type="math_number">
                      <field name="NUM">2</field>
                    </block>
                  </value>
                  <value name="ADD2">
                    <block type="math_number">
                      <field name="NUM">3</field>
                    </block>
                  </value>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        type: 'controls_flow_statements'
      }
    ]
  },
  {
    kind: 'category',
    name: '%{BKY_CATEGORY_LOGIC}',
    categorystyle: 'logic_category',
    cssConfig: {
      icon: 'customIcon fa fa-equals'
    },
    contents: [
      {
        kind: 'block',
        blockxml: `
          <block type="logic_compare">
            <value name="A">
              <block type="math_number">
                <field name="NUM">1</field>
              </block>
            </value>
            <value name="B">
              <block type="math_number">
                <field name="NUM">1</field>
              </block>
            </value>
          </block>`
      },
      {
        kind: 'block',
        blockxml: `
          <block type="logic_operation">
            <value name="A">
              <block type="logic_compare">
                <value name="A">
                  <block type="math_number">
                    <field name="NUM">1</field>
                  </block>
                </value>
                <value name="B">
                  <block type="math_number">
                    <field name="NUM">1</field>
                  </block>
                </value>
              </block>
            </value>
            <value name="B">
              <block type="logic_compare">
                <value name="A">
                  <block type="math_number">
                    <field name="NUM">2</field>
                  </block>
                </value>
                <field name="OP">GT</field>
                <value name="B">
                  <block type="math_number">
                    <field name="NUM">1</field>
                  </block>
                </value>
              </block>
            </value>
          </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="logic_negate">
              <value name="BOOL">
                <block type="logic_boolean">
                  <field name="BOOL">TRUE</field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        type: 'logic_boolean'
      },
      {
        kind: 'block',
        blockxml: `
          <block type="math_number_property">
            <value name="NUMBER_TO_CHECK">
              <block type="math_number">
                <field name="NUM">2</field>
              </block>
            </value>
          </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="lists_isEmpty">
              <value name="VALUE">
                <block type="lists_create_empty">
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="text_isEmpty">
              <value name="VALUE">
                <block type="text">
                  <field name="TEXT"></field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        type: 'logic_null'
      },
      {
        kind: 'block',
        blockxml: `
            <block type="logic_ternary">
              <value name="IF">
                <block type="logic_boolean">
                  <field name="BOOL">TRUE</field>
                </block>
              </value>
              <value name="THEN">
                <block type="math_number">
                  <field name="NUM">1</field>
                </block>
              </value>
              <value name="ELSE">
                <block type="math_number">
                  <field name="NUM">0</field>
                </block>
              </value>
            </block>`
      }
    ]
  },
  {
    kind: 'category',
    name: '%{BKY_CATEGORY_MATH}',
    categorystyle: 'math_category',
    cssConfig: {
      icon: 'customIcon fa fa-plus'
    },
    contents: [
      {
        kind: 'block',
        blockxml: `
            <block type="math_number">
              <field name="NUM">123</field>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
          <block type="math_arithmetic">
            <value name="A">
              <block type="math_number">
                <field name="NUM">1</field>
              </block>
            </value>
            <value name="B">
              <block type="math_number">
                <field name="NUM">1</field>
              </block>
            </value>
          </block>`
      },
      {
        kind: 'block',
        blockxml: `
          <block type="math_single">
            <value name="NUM">
              <block type="math_number">
                <field name="NUM">2</field>
              </block>
            </value>
          </block>`
      },
      {
        kind: 'block',
        blockxml: `
          <block type="math_trig">
            <value name="NUM">
              <block type="math_number">
                <field name="NUM">90</field>
              </block>
            </value>
          </block>`
      },
      {
        kind: 'block',
        type: 'math_constant'
      },
      {
        kind: 'block',
        blockxml: `
          <block type="math_round">
            <value name="NUM">
              <block type="math_number">
                <field name="NUM">1.5</field>
              </block>
            </value>
          </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="math_on_list">
              <value name="LIST">
                <block type="lists_create_with">
                  <mutation items="3"></mutation>
                  <value name="ADD0">
                    <block type="math_number">
                      <field name="NUM">1</field>
                    </block>
                  </value>
                  <value name="ADD1">
                    <block type="math_number">
                      <field name="NUM">2</field>
                    </block>
                  </value>
                  <value name="ADD2">
                    <block type="math_number">
                      <field name="NUM">3</field>
                    </block>
                  </value>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
          <block type="math_modulo">
            <value name="DIVIDEND">
              <block type="math_number">
                <field name="NUM">7</field>
              </block>
            </value>
            <value name="DIVISOR">
              <block type="math_number">
                <field name="NUM">3</field>
              </block>
            </value>
          </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="math_constrain">
              <value name="VALUE">
                <block type="math_number">
                  <field name="NUM">50</field>
                </block>
              </value>
              <value name="LOW">
                <block type="math_number">
                  <field name="NUM">1</field>
                </block>
              </value>
              <value name="HIGH">
                <block type="math_number">
                  <field name="NUM">100</field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="math_random_int">
              <value name="FROM">
                <block type="math_number">
                  <field name="NUM">1</field>
                </block>
              </value>
              <value name="TO">
                <block type="math_number">
                  <field name="NUM">100</field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        type: 'math_random_float'
      },
      {
        kind: 'block',
        blockxml: `
            <block type="math_atan2">
              <value name="X">
                <block type="math_number">
                  <field name="NUM">1</field>
                </block>
              </value>
              <value name="Y">
                <block type="math_number">
                  <field name="NUM">1</field>
                </block>
              </value>
            </block>`
      }
    ]
  },
  {
    kind: 'category',
    name: '%{BKY_CATEGORY_LIST}',
    categorystyle: 'list_category',
    cssConfig: {
      icon: 'customIcon fa fa-list'
    },
    contents: [
      {
        kind: 'block',
        type: 'lists_create_empty'
      },
      {
        kind: 'block',
        blockxml: `
            <block type="lists_create_with">
              <mutation items="3"></mutation>
              <value name="ADD0">
                <block type="math_number">
                  <field name="NUM">1</field>
                </block>
              </value>
              <value name="ADD1">
                <block type="math_number">
                  <field name="NUM">2</field>
                </block>
              </value>
              <value name="ADD2">
                <block type="math_number">
                  <field name="NUM">3</field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="lists_repeat">
              <value name="ITEM">
                <block type="math_number">
                  <field name="NUM">1</field>
                </block>
              </value>
              <value name="NUM">
                <block type="math_number">
                  <field name="NUM">5</field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="lists_length">
              <value name="VALUE">
                <block type="lists_create_with">
                  <mutation items="3"></mutation>
                  <value name="ADD0">
                    <block type="math_number">
                      <field name="NUM">1</field>
                    </block>
                  </value>
                  <value name="ADD1">
                    <block type="math_number">
                      <field name="NUM">2</field>
                    </block>
                  </value>
                  <value name="ADD2">
                    <block type="math_number">
                      <field name="NUM">3</field>
                    </block>
                  </value>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="lists_indexOf">
              <value name="VALUE">
                <block type="lists_create_with">
                  <mutation items="3"></mutation>
                  <value name="ADD0">
                    <block type="math_number">
                      <field name="NUM">1</field>
                    </block>
                  </value>
                  <value name="ADD1">
                    <block type="math_number">
                      <field name="NUM">2</field>
                    </block>
                  </value>
                  <value name="ADD2">
                    <block type="math_number">
                      <field name="NUM">3</field>
                    </block>
                  </value>
                </block>
              </value>
              <value name="FIND">
                <block type="math_number">
                  <field name="NUM">1</field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="lists_getIndex">
              <value name="VALUE">
                <block type="lists_create_with">
                  <mutation items="3"></mutation>
                  <value name="ADD0">
                    <block type="math_number">
                      <field name="NUM">1</field>
                    </block>
                  </value>
                  <value name="ADD1">
                    <block type="math_number">
                      <field name="NUM">2</field>
                    </block>
                  </value>
                  <value name="ADD2">
                    <block type="math_number">
                      <field name="NUM">3</field>
                    </block>
                  </value>
                </block>
              </value>
              <value name="AT">
                <block type="math_number">
                  <field name="NUM">1</field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="lists_setIndex">
              <value name="LIST">
                <block type="lists_create_with">
                  <mutation items="3"></mutation>
                  <value name="ADD0">
                    <block type="math_number">
                      <field name="NUM">1</field>
                    </block>
                  </value>
                  <value name="ADD1">
                    <block type="math_number">
                      <field name="NUM">2</field>
                    </block>
                  </value>
                  <value name="ADD2">
                    <block type="math_number">
                      <field name="NUM">3</field>
                    </block>
                  </value>
                </block>
              </value>
              <value name="AT">
                <block type="math_number">
                  <field name="NUM">1</field>
                </block>
              </value>
              <value name="TO">
                <block type="math_number">
                  <field name="NUM">4</field>
                </block>
              </value>
            </block>`
      }
    ]
  },
  {
    kind: 'category',
    name: '%{BKY_CATEGORY_TEXT}',
    categorystyle: 'text_category',
    cssConfig: {
      icon: 'customIcon fa fa-font'
    },
    contents: [
      {
        kind: 'block',
        blockxml: `
            <block type="text_print">
              <value name="TEXT">
                <block type="text">
                  <field name="TEXT"></field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        type: 'text'
      },
      {
        kind: 'block',
        type: 'text_multiline'
      },
      {
        kind: 'block',
        blockxml: `
            <block type="text_join">
              <value name="ADD0">
                <block type="text">
                  <field name="TEXT">Hello </field>
                </block>
              </value>
              <value name="ADD1">
                <block type="text">
                  <field name="TEXT">World</field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="text_length">
              <value name="VALUE">
                <block type="text">
                  <field name="TEXT">Hello</field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="text_indexOf">
              <value name="VALUE">
                <block type="text">
                  <field name="TEXT">Hello World</field>
                </block>
              </value>
              <value name="FIND">
                <block type="text">
                  <field name="TEXT">lo</field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="text_charAt">
              <value name="VALUE">
                <block type="text">
                  <field name="TEXT">Hello World</field>
                </block>
              </value>
              <value name="AT">
                <block type="math_number">
                  <field name="NUM">4</field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="text_getSubstring">
              <value name="STRING">
                <block type="text">
                  <field name="TEXT">Hello World</field>
                </block>
              </value>
              <value name="AT1">
                <block type="math_number">
                  <field name="NUM">4</field>
                </block>
              </value>
              <value name="AT2">
                <block type="math_number">
                  <field name="NUM">8</field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="text_count">
              <value name="TEXT">
                <block type="text">
                  <field name="TEXT">the the big one</field>
                </block>
              </value>
              <value name="SUB">
                <block type="text">
                  <field name="TEXT">the</field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
          <block type="text_replace">
            <value name="TEXT">
              <block type="text">
                <field name="TEXT">Hello World</field>
              </block>
            </value>
            <value name="FROM">
              <block type="text">
                <field name="TEXT">World</field>
              </block>
            </value>
            <value name="TO">
              <block type="text">
                <field name="TEXT">iFBlock</field>
              </block>
            </value>
          </block>`
      }
    ]
  },
  {
    kind: 'category',
    name: '%{BKY_CATEGORY_VARIABLE}',
    categorystyle: 'variable_category',
    cssConfig: {
      icon: 'customIcon fa fa-align-justify'
    },
    custom: 'VARIABLE'
  },
  {
    kind: 'category',
    name: '%{BKY_CATEGORY_FUNCTION}',
    categorystyle: 'procedures_category',
    cssConfig: {
      icon: 'customIcon fa fa-inbox'
    },
    custom: 'PROCEDURE'
  }
]

export default toolbox
